export default class PaymentUrlRequest {
    constructor(priceId = '', videoId = '', type = 'subscription') {
        this.priceId = priceId,
            this.videoId = videoId,
            this.type = type

    }
}